import CryptoJS from "crypto-js";
import { secretKey } from "./constants";

export const dataEncrypt = (txt:String) =>{
    //return CryptoJS.AES.encrypt(JSON.stringify(txt),secretKey).toString();
    return CryptoJS.HmacSHA1(txt.toString(),secretKey).toString();
}